import React, { useState, useEffect } from 'react';
import './SequenceSelector.css';

const SequenceSelector = ({ duration, startTime, segmentDuration, onChange }) => {
  const [localStart, setLocalStart] = useState(startTime);
  const [localEnd, setLocalEnd] = useState(startTime + segmentDuration);
  const [dragging, setDragging] = useState(false);

  useEffect(() => {
    setLocalStart(startTime);
    setLocalEnd(startTime + segmentDuration);
  }, [startTime, segmentDuration]);

  const handleBarChange = (e) => {
    if (!dragging) {
      const newStart = parseFloat(e.target.value);
      const newEnd = newStart + segmentDuration;
      setLocalStart(newStart);
      setLocalEnd(newEnd);
      onChange({ start: newStart, end: newEnd });
    }
  };

  const handleSegmentDragStart = () => {
    setDragging(true);
  };

  const handleSegmentDrag = (e) => {
    if (dragging) {
      const newStart = parseFloat(e.target.value);
      const newEnd = newStart + segmentDuration;
      setLocalStart(newStart);
      setLocalEnd(newEnd);
      onChange({ start: newStart, end: newEnd });
    }
  };

  const handleSegmentDragEnd = () => {
    setDragging(false);
  };

  return (
    <div className="time-selector">
      <div>Choisir un segment</div>
      <input
        type="range"
        min="0"
        max={duration - segmentDuration}
        value={localStart}
        onChange={handleBarChange}
        className="time-bar"
        style={{ width: '100%' }}
      />
      <div>Durée<br/>
        30 secondes max. Droit d’auteur oblige ! ;)</div>
      <div className="segment-info">
        {`${Math.floor(localStart / 60)}:${Math.floor(localStart % 60).toString().padStart(2, '0')} - ${Math.floor(localEnd / 60)}:${Math.floor(localEnd % 60).toString().padStart(2, '0')}`}
      </div>
    </div>
  );
};

export default SequenceSelector;
